// custom typefaces
// import "@fontsource/montserrat";
// import "@fontsource/merriweather";
import React from "react";
import "./src/utils/typography";
import "@fontsource/lato";
import "@fontsource/roboto";
import LayoutSimple from "./src/components/layout--simple";

import "prismjs/themes/prism.css";

const getPageTitle = (pathname) => {
	const normalized = pathname.replace(/^\/+|\/+$/g, "");

	if (!normalized) {
		return "";
	}

	return normalized
		.split("/")
		.filter(Boolean)
		.map((segment) => segment.replace(/-/g, " "))
		.map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
		.join(" / ");
};

export const wrapPageElement = ({ element, props }) => {
	const title = getPageTitle(props.location.pathname);

	return (
		<LayoutSimple location={props.location} title={title}>
			{element}
		</LayoutSimple>
	);
};
